// CacheKey dbcdec720a62fe023b05659c09f12d5d
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-SUFFOLK_CARE_COLLABORATIVE": {
    models: {
      encounter: "participant info",
      encounters: "participant information",
      Encounter: "Participant Info",
      Encounters: "Participant Information",
      patient: "participant",
      patients: "participants",
      Patient: "Participant",
      Patients: "Participants",
      unit: "participant list",
      units: "participant lists",
      Unit: "Participant List",
      Units: "Participant Lists"
    },
    ribbon: {
      encounters: "Participant Information",
      patient_information: "Summary"
    },
    exports: {
      defaults: {
        encounter: {
          id: "Participant Info ID",
          patient_class: "Participant Class",
          status: "Participant Info Status"
        },
        patient: {
          id: "Participant ID",
          name: "Participant Name"
        },
        unit: {
          group: "Participant List Group",
          name: "Participant List",
          type: "Participant List Type"
        }
      }
    },
    admitted_patients: {
      title: "Admitted Participants"
    },
    monitored_patients: {
      title: "Monitored Participants"
    },
    my_patient_panel: {
      title: "My Participant Panel"
    },
    patients_search: {
      nav_menu: "Participants"
    },
    plans: {
      patient_information: "Participant Info"
    }
  }
}

